@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/buttons.scss' as *;

.InfoExpand {
  @extend %font-family-primary;
  @extend %button;

  background-color: transparent;
  color: $color-secondary-purple;
  padding: 0;
  min-width: 1.5em; // overwrite the width of button that having default min-width: 95px

  &.ArrowStyle {
    margin-top: 2px;
    width: 26px;
    height: 26px;
    color: $theme-filter-icon-color;
  }

  &:active,
  &:hover,
  &:focus {
    outline: none;
    color: $color-primary-purple;
  }
}
